import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=37e77d99&"
import script from "./PrivacyPolicy.js?vue&type=script&lang=js&"
export * from "./PrivacyPolicy.js?vue&type=script&lang=js&"
import style0 from "./PrivacyPolicy.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports